/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AuditReportDto } from '../../models/audit-report-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAfterSalesDetails$Params {
  auditReportId: string;
}

export function getAfterSalesDetails(
  http: HttpClient,
  rootUrl: string,
  params: GetAfterSalesDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<AuditReportDto>> {
  const rb = new RequestBuilder(rootUrl, getAfterSalesDetails.PATH, 'get');
  if (params) {
    rb.path('auditReportId', params.auditReportId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuditReportDto>;
    }),
  );
}

getAfterSalesDetails.PATH = '/service/v1/afterSales/{auditReportId}';
